export class IncomingCall {
  readonly id: string;
  readonly connectedAt?: Date;
  readonly connectingAt: Date;
  readonly caller: string;
  readonly recipient: string;
  readonly contactId?: string;

  /**
   * Whether this call is transferred from another user. The call may originally be
   * either inbound or outbound.
   */
  readonly isTransferred: boolean;

  /**
   * Whether this call is inbound. If the call is outbound, then it should be transferred.
   */
  readonly isInbound: boolean;

  constructor(base?: Partial<IncomingCall>) {
    if (base) {
      Object.assign(this, base);
    }

    this.connectingAt = new Date(this.connectingAt);

    if (this.connectedAt) {
      this.connectedAt = new Date(this.connectedAt);
    }
  }
}